import {
  VerifyAllSourcesWithModelsArgs,
  VerifyAllSourcesWithModelsReturn,
} from './model';

export const verifyAllSourcesWithModels = (
  connectorData: VerifyAllSourcesWithModelsArgs
): VerifyAllSourcesWithModelsReturn => {
  const { sources, models } = connectorData;

  if (!sources || !models) {
    return false;
  }
  const sourcesNames = sources.map((source) => source.preconfiguredSourceName);

  const compatibleSources = models.flatMap(
    (model) => model.compatiblePreconfiguredSources
  );

  return sourcesNames.every((source) => compatibleSources.includes(source));
};
